var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.token)?_c('span',{staticClass:"highlight"},[_vm._v(" "+_vm._s(_vm.token.text)+" ")]):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }